import React from 'react';

// Define the entity details context
export const EntityDetailsContext = React.createContext(null);
